import config from './config.json';
import { merge } from 'lodash';

const environment = process.env.REACT_APP_ENV || 'development';
// console.log(process.env.REACT_APP_ENV);
const environmentConfig = config[environment];
const finalConfig = merge( config.default, environmentConfig);

global.gConfig = finalConfig;
// console.log(global.gConfig);
